import { useCallback, useEffect, useState } from "react";
import axiosClient from "@/config/api/axios";
import { LLM_CONNECTIONS } from "@/config/api/endpoints";

export function useLlmProviderConnections() {
  const [connections, setConnections] = useState([]);
  const [keys, setKeys] = useState({});
  const refresh = useCallback(
    () =>
      axiosClient
        .get(LLM_CONNECTIONS)
        .then(({ data }) => setConnections(data))
        .catch(() => {}),
    [],
  );
  useEffect(() => {
    refresh();
  }, [refresh]);
  const save = async (provider) => {
    const apiKey = keys[provider]?.trim();
    if (!apiKey) return;
    await axiosClient.put(`${LLM_CONNECTIONS}/${provider}`, {
      api_key: apiKey,
    });
    setKeys((previous) => ({ ...previous, [provider]: "" }));
    refresh();
  };
  const revoke = async (provider) => {
    await axiosClient.delete(`${LLM_CONNECTIONS}/${provider}`);
    refresh();
  };
  const setKey = (provider, value) =>
    setKeys((previous) => ({ ...previous, [provider]: value }));
  return { connections, keys, revoke, save, setKey };
}
